// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getAllBrandsDataView } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import loadAllBrands from "@insite/client-framework/Store/Pages/Brands/Handlers/LoadAllBrands";
import loadBrandsAlphabet from "@insite/client-framework/Store/Pages/Brands/Handlers/LoadBrandsAlphabet";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    marketingGeneralPromotionTitle = "marketingGeneralPromotionTitle",
    marketingGeneralPromoContent = "marketingGeneralPromoContent",
    marketingFeaturedProducts = "marketingFeaturedProducts",
    marketingGeneralPromoImage = "marketingGeneralPromoImage",
    isFullWidth = "isFullWidth",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.marketingGeneralPromotionTitle]: string;
        [fields.marketingGeneralPromoContent]: string;
        [fields.marketingFeaturedProducts]: string;
        [fields.marketingGeneralPromoImage]: string;
        [fields.isFullWidth]: boolean;
    };
}
// const mapStateToProps = (state: ApplicationState) => {
//     const allBrandsDataView = getAllBrandsDataView(state);
//     return {
//         shouldLoadBrandAlphabet:
//             !state.pages.brands.brandAlphabetState.value && !state.pages.brands.brandAlphabetState.isLoading,
//         shouldLoadAllBrandList: !allBrandsDataView.value && !allBrandsDataView.isLoading,
//     };
// };

// const mapDispatchToProps = {
//     loadBrandsAlphabet,
//     loadAllBrands,
// };

type Props =
    // ReturnType<typeof mapStateToProps> &
    // ResolveThunks<typeof mapDispatchToProps> &
    OwnProps & HasShellContext & PageProps;

class BrandsPage extends React.Component<Props> {
    // XNG-Changes: removing unnecessary ootb code
    // UNSAFE_componentWillMount() {
    // const { loadBrandsAlphabet, shouldLoadBrandAlphabet, shouldLoadAllBrandList, loadAllBrands } = this.props;
    //     if (shouldLoadBrandAlphabet) {
    //         loadBrandsAlphabet();
    //     }
    //     if (shouldLoadAllBrandList) {
    //         loadAllBrands({
    //             sort: "name asc",
    //             select: "id,detailPagePath,name",
    //         });
    //     }
    // }

    render() {
        return (
            <Page fullWidth={this.props.fields.isFullWidth ? [true, true, true, true, true] : undefined}>
                <Zone contentId={this.props.id} zoneName="Content" />
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: /* connect(mapStateToProps, mapDispatchToProps) */ withIsInShell(BrandsPage),
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: true,
        pageType: "System",
        fieldDefinitions: [
            {
                name: fields.marketingGeneralPromotionTitle,
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.marketingGeneralPromoContent,
                defaultValue: "",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.marketingGeneralPromoImage,
                defaultValue: "",
                editorTemplate: "ImagePickerField",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.marketingFeaturedProducts,
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.isFullWidth,
                displayName: "Full Width",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default pageModule;

export const BrandsPageContext = "BrandsPage";
